import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch, RiskProfile } from '../robotapi';

export interface RiskProfileResponse {
    data: RiskProfile[];
}

const riskProfilePath = (riskReducation: boolean, endDate: DateTime) =>
    buildEndpoint(
        ['riskprofiles'],
        [
            { key: 'include', value: 'funds' },
            { key: 'automaticRiskReduction', value: riskReducation + '' },
            { key: 'investmentEndDate', value: endDate.toFormat('yyyy-MM-dd') },
        ],
    );

const filteredOutRiskProfiles = [20, 21, 22, 23, 24];

export const useGetRiskProfiles = (riskReduction: boolean, endDate: DateTime) => {
    const riskProfilesQuery = useQuery<RiskProfileResponse>(
        ['riskprofiles', riskReduction + '', endDate.year + ''],
        async () => {
            const getRiskProfiles = apifetch<RiskProfileResponse>(riskProfilePath(riskReduction, endDate), 'GET');
            return getRiskProfiles();
        },
    );

    if (riskProfilesQuery?.data?.data && riskProfilesQuery.data.data.length > 0) {
        riskProfilesQuery.data.data =
            riskProfilesQuery.data.data.filter((profile) => !filteredOutRiskProfiles.includes(profile?.id)) ?? [];
    }

    return riskProfilesQuery;
};
